import { AiFillEdit, AiOutlineCalendar } from 'react-icons/ai'
import { Event } from '../index.page'
import { Link } from '@inertiajs/react'
import { EVENT_STATUS_LABELS } from '@/types/events'

export default function HomeEventCard({ event }: { event: Event }) {
  const statusLabel = EVENT_STATUS_LABELS[event.status] || event.status

  return (
    <div className="bg-white border border-[#f0f0f0] border-solid h-[340px] rounded-[2px] w-[300px]">
      <div className="flex flex-col h-[340px] items-start overflow-clip relative rounded-[inherit] w-[300px]">
        {/* Status Badge */}
        <div className="box-border flex flex-col items-start justify-center overflow-clip p-[12px] relative shrink-0">
          <div className="h-[22px] relative shrink-0">
            <div className="flex gap-[8px] h-[22px] items-center">
              <div className={`rounded-full w-[6px] h-[6px] status-indicator-${event.status}`} />
              <p className=" leading-[22px] text-[14px] text-[rgba(0,0,0,0.85)] whitespace-nowrap">
                {statusLabel}
              </p>
            </div>
          </div>
        </div>

        {/* Cover Image */}
        <div className="flex flex-col h-[140px] items-start relative shrink-0 w-full bg-[#1a3a52]">
          {event?.banner && (
            <img
              alt={event.name}
              className="absolute inset-0 object-cover w-full h-full"
              src={event.banner}
            />
          )}
        </div>

        {/* Body */}
        <div className="box-border flex flex-col gap-[20px] items-start p-[24px] relative shrink-0 w-full">
          <div className="flex flex-col gap-[8px] items-start relative shrink-0 w-full">
            {/* Event Name */}
            <div className="flex flex-col items-start justify-center overflow-clip relative shrink-0 w-full">
              <p className="font-medium leading-[24px] text-[14px] text-[rgba(0,0,0,0.85)] whitespace-nowrap overflow-hidden text-ellipsis w-full">
                {event.name}
              </p>
            </div>

            {/* Date Range */}
            <div className="flex gap-[8px] items-center overflow-clip relative shrink-0 w-full">
              <AiOutlineCalendar />
              <p className=" leading-[22px] text-[14px] text-[rgba(0,0,0,0.85)] whitespace-nowrap">
                {event.start_date} - {event.end_date}
              </p>
            </div>
          </div>

          {/* Edit Button */}
          <Link
            href={`/events/${event.slug}`}
            className="!bg-[#132b51] border border-[#132b51] border-solid rounded-[2px] shrink-0 w-full hover:bg-[#1a4169] transition-colors block"
          >
            <div className="box-border flex gap-[8px] items-center justify-center px-[16px] py-[5px] relative rounded-[inherit]">
              <AiFillEdit className="text-white" />
              <span className="leading-[22px] text-[14px] text-center text-white whitespace-nowrap">
                Edit Event
              </span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
